import { Button } from '@nexelem/components';
import { StaticModal, createModal } from '@nexelem/modals';
import { Trans } from 'react-i18next';
import { useTableTranslation } from '../../translations';

type OverrideCurrentViewModalProps = {
  savedViewName: string;
  onOverride: () => void;
  onSaveAsNewView: () => void;
};
const OverrideCurrentViewModal = ({ savedViewName, onOverride, onSaveAsNewView }: OverrideCurrentViewModalProps) => {
  const { t } = useTableTranslation();

  const handleOverride = () => {
    onOverride();
    closeOverrideCurrentViewModal();
  };

  const handleSaveAsNewView = () => {
    onSaveAsNewView();
    closeOverrideCurrentViewModal();
  };

  return (
    <StaticModal maxWidth="lg" onClose={closeOverrideCurrentViewModal}>
      <StaticModal.Header withCloseButton>{t('overrideCurrentViewModalHeader')}</StaticModal.Header>
      <StaticModal.Content className="mb-4 flex flex-col gap-6">
        <div className="text-s18">
          <Trans>{t('overrideCurrentViewModalDescription', { name: savedViewName })}</Trans>
        </div>
      </StaticModal.Content>
      <StaticModal.Footer>
        <Button variant="text" onClick={closeOverrideCurrentViewModal}>
          {t('cancel')}
        </Button>
        <Button variant="outlined" onClick={handleSaveAsNewView}>
          {t('saveAsNewView')}
        </Button>
        <Button onClick={handleOverride}>{t('override')}</Button>
      </StaticModal.Footer>
    </StaticModal>
  );
};

export const { closeOverrideCurrentViewModal, openOverrideCurrentViewModal } = createModal(OverrideCurrentViewModal, {
  name: 'OverrideCurrentViewModal',
});
